import React from 'react'
import styled from 'styled-components'
import * as Utils from '@services/utils'
import { getCellContent } from '@services/table'
import {
    requestDateFormat,
    dateFormat,
    completionDateFormat,
    existingDanceCompletionDateFormat,
} from '@services/dances'
import i18n from '@localization/i18n'

const getFullNameFromArr = (artists) => {
    if (!Utils.isEmpty(artists)) {
        return artists.map((a) => a.first_name + ' ' + a.last_name).join(', ')
    }
}

const getCoChoreographersMix = (dance) => {
    const choreographerName =
        dance['choreographer']?.first_name +
        ' ' +
        dance['choreographer']?.last_name
    let res = []
    const coChoreographersFromArr = getFullNameFromArr(
        dance['co_choreographers']
    )
    const coChoreographersString = dance['co_choreographers_string']
    res = coChoreographersFromArr
        ? coChoreographersFromArr + ', ' + coChoreographersString
        : coChoreographersString

    let resultArray = res?.split(', ')

    resultArray = resultArray?.filter((item, index) => {
        return (
            resultArray?.indexOf(item) === index && item !== choreographerName
        )
    })

    return resultArray?.join(', ')
}

export default ({ item, expanded }) => {
    const dance = item
    const columns = [
        {
            property: 'song',
            subProperty: 'name',
            label: i18n.t('dances_expanded_row.original_name'),
        },
        {
            property: 'co_choreographers',
            label: i18n.t('dances_expanded_row.co_choreographers'),
            align: 'center',
            minWidth: '98px',
            cell: getCoChoreographersMix,
        },
        {
            property: 'video_url',
            label: '',
            cell: (dance) =>
                dance.video_url && (
                    <Hyperlink href={dance.video_url} target="_blank">
                        {i18n.t('dances_expanded_row.link_to_dance_video')}
                    </Hyperlink>
                ),
        },
        {
            property: 'request_date',
            label: i18n.t('dances_expanded_row.request_date'),
            cell: (dance) =>
                dance['created_date'] &&
                Utils.formatDate(dance['request_date'], requestDateFormat),
        },
        {
            property: 'approval_date',
            label: i18n.t('dances_expanded_row.approval_date'),
            cell: (dance) =>
                dance['approval_date'] &&
                Utils.formatDate(dance['approval_date'], dateFormat),
        },
        {
            property: 'completion_date',
            label: i18n.t('dances_expanded_row.completion_date'),
            cell: (dance) =>
                dance['completion_date']
                    ? dance['status'] == 'קיים ריקוד'
                        ? Utils.formatDate(
                              dance['completion_date'],
                              existingDanceCompletionDateFormat
                          )
                        : Utils.formatDate(
                              dance['completion_date'],
                              completionDateFormat
                          )
                    : null,
        },
        {
            property: 'song',
            subProperty: 'video_url',
            label: '',
            cell: (dance) =>
                dance.song.video_url && (
                    <Hyperlink href={dance.song.video_url} target="_blank">
                        {i18n.t('dances_expanded_row.link_to_original_song')}
                    </Hyperlink>
                ),
        },
        {
            property: 'song',
            subProperty: 'lyrics',
            label: '',
            cell: (dance) =>
                dance.song.lyrics && (
                    <Hyperlink href={dance.song.lyrics} target="_blank">
                        {i18n.t('dances_expanded_row.link_to_lyrics')}
                    </Hyperlink>
                ),
        },
        {
            property: 'notes',
            label: i18n.t('dances_expanded_row.notes'),
        },
    ]

    return (
        <Container>
            {Utils.chunk(columns, 3).map((itemsChunk, chunk_i) => (
                <Col key={'expanded-col-' + chunk_i}>
                    {itemsChunk.map((col, ci) => {
                        return (
                            <Item key={'expanded-dance-item-' + ci}>
                                <Label>
                                    {col.label ? col.label + ": " : null}
                                    {col.label && '\u00A0'}
                                </Label>
                                <Value>{getCellContent(dance, col)}</Value>
                            </Item>
                        )
                    })}
                </Col>
            ))}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    padding: 8px;
    @media (max-width: 768px) {
        display: initial;
    }
`

const Item = styled.div`
    display: flex;
    font-size: 15px;
    /* padding: 4px 0px; */
    @media (max-width: 480px) {
        display: initial;
        margin-bottom: 8px;
    }
`

const Col = styled.div`
    flex: 1;
    display: flex;
    padding: 0px 12px;
    flex-direction: column;
`
const Label = styled.div`
    font-weight: 600;
`
const Value = styled.div`
    /* padding: 0px 8px; */
`

const Hyperlink = styled.a`
    &:focus {
        outline: none;
        border: none;
    }
`
